(function () {
  var KEY = 'n1-recent-searches';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var fmt = (window.KSX_CART && window.KSX_CART.moneyFormat) || '{{amount}}';
    var n = Number(cents) / 100;
    function f(d, ts, ds) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      return f(2, ',', '.');
    });
  }
  function toCents(v) { if (v == null) return 0; var s = String(v); return s.indexOf('.') > -1 ? Math.round(parseFloat(s) * 100) : parseInt(s, 10) || 0; }
  function hl(text, q) {
    text = String(text || '');
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return esc(text);
    return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + q.length)) + '</b>' + esc(text.slice(i + q.length));
  }
  function getRecent() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setRecent(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {} }

  function init(root) {
    if (root.__n1) return; root.__n1 = true;
    var ar = root.getAttribute('data-ar') === '1';
    var form = root.querySelector('form');
    var input = root.querySelector('[data-n1-q]');
    var clear = root.querySelector('[data-n1-qclear]');
    var panel = root.querySelector('[data-n1-sr]');
    var idle = root.querySelector('[data-n1-sr-idle]');
    var res = root.querySelector('[data-n1-sr-res]');
    var recentWrap = root.querySelector('[data-n1-sr-recent-wrap]');
    var recentBox = root.querySelector('[data-n1-sr-recent]');
    var url = root.getAttribute('data-url');
    var searchUrl = root.getAttribute('data-search-url');
    var predictiveOk = true;
    var vendors = [];
    try { vendors = JSON.parse(root.querySelector('[data-n1-vendors]').textContent) || []; } catch (e) {}
    var timer = null, seq = 0, last = '';
    var T = ar ? { sugg: 'اقتراحات', prod: 'منتج', inBrand: 'في العلامة التجارية', all: 'عرض كل النتائج', none: 'لا توجد نتائج', cats: 'الأقسام' } : { sugg: 'Suggestions', prod: 'Products', inBrand: 'in brands', all: 'See all results', none: 'No results', cats: 'Categories' };

    function searchHref(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); root.classList.add('is-open'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); root.classList.remove('is-open'); }
    function paintRecent() {
      var a = getRecent();
      recentWrap.hidden = !a.length;
      recentBox.innerHTML = a.map(function (q) { return '<a class="n1-sr__chip" href="' + esc(searchHref(q)) + '">' + esc(q) + '</a>'; }).join('');
    }
    function remember(q) { q = q.trim(); if (!q) return; var a = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); setRecent(a); }

    function render(q, r) {
      var queries = (r.queries || []).slice(0, 4);
      var products = (r.products || []).slice(0, 6);
      var cols = (r.collections || []).slice(0, 3);
      var ql = q.toLowerCase();
      var brands = vendors.filter(function (v) { return v.toLowerCase().indexOf(ql) > -1; }).slice(0, 3);
      var h = '<div class="n1-sr__group"><div class="n1-sr__label">' + T.sugg + '</div>';
      var seen = {};
      if (!queries.some(function (s) { return s.text.toLowerCase() === ql; })) { h += '<a class="n1-sr__row" role="option" href="' + esc(searchHref(q)) + '"><b>' + esc(q) + '</b></a>'; }
      queries.forEach(function (s) { if (seen[s.text]) return; seen[s.text] = 1; h += '<a class="n1-sr__row" role="option" href="' + esc(searchHref(s.text)) + '">' + hl(s.text, q) + '</a>'; });
      brands.forEach(function (v) { h += '<a class="n1-sr__row" role="option" href="/collections/vendors?q=' + encodeURIComponent(v) + '">' + hl(v, q) + ' <span class="n1-sr__in">' + T.inBrand + '</span></a>'; });
      h += '</div>';
      if (cols.length) {
        h += '<div class="n1-sr__group"><div class="n1-sr__label">' + T.cats + '</div>';
        cols.forEach(function (c) { h += '<a class="n1-sr__row" role="option" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; });
        h += '</div>';
      }
      if (products.length) {
        h += '<div class="n1-sr__group"><div class="n1-sr__label">' + T.prod + '</div>';
        products.forEach(function (p) {
          var price = toCents(p.price), cmp = toCents(p.compare_at_price_max || p.compare_at_price_min || 0);
          var sale = cmp > price;
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          h += '<a class="n1-sr__prod" role="option" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<span class="n1-sr__pbody"><span class="n1-sr__pv">' + esc(p.vendor || '') + '</span><span class="n1-sr__pt">' + hl(p.title, q) + '</span></span>' +
            '<span class="n1-sr__pp">' + (sale ? '<s>' + money(cmp) + '</s>' : '') + '<span>' + (sale ? '<i>-' + Math.round((cmp - price) * 100 / cmp) + '%</i>' : '') + '<b' + (sale ? ' class="is-sale"' : '') + '>' + money(price) + '</b></span></span></a>';
        });
        h += '</div>';
      } else if (!queries.length && !brands.length && !cols.length) {
        h += '<p class="n1-sr__none">' + T.none + '</p>';
      }
      h += '<a class="n1-sr__all" href="' + esc(searchHref(q)) + '">' + T.all + ' «' + esc(q) + '»</a>';
      res.innerHTML = h;
    }

    function viaSection(q) {
      var u = searchHref(q) + '&section_id=n1-search-json';
      return fetch(u).then(function (r) { return r.text(); }).then(function (t) {
        var d = document.createElement('div'); d.innerHTML = t;
        var s = d.querySelector('[data-n1-sj]');
        var list = []; try { list = JSON.parse(s ? s.textContent : '[]'); } catch (e) {}
        return { products: list };
      });
    }
    function viaPredictive(q) {
      var u = url + '?q=' + encodeURIComponent(q) + '&resources[type]=query,product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) { predictiveOk = false; throw new Error('predictive'); }
        return r.json();
      }).then(function (j) { return (j.resources && j.resources.results) || {}; });
    }

    function run() {
      var q = input.value.trim();
      clear.hidden = !input.value;
      if (!q) { res.hidden = true; idle.hidden = false; paintRecent(); last = ''; return; }
      if (q === last) return;
      last = q;
      var my = ++seq;
      var p = predictiveOk ? viaPredictive(q).catch(function () { return viaSection(q); }) : viaSection(q);
      p.then(function (r) { if (my !== seq) return; render(q, r); idle.hidden = true; res.hidden = false; }).catch(function () {});
    }

    input.addEventListener('focus', function () { paintRecent(); open(); });
    input.addEventListener('input', function () { open(); clearTimeout(timer); timer = setTimeout(run, 200); });
    clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    form.addEventListener('submit', function () { remember(input.value); });
    panel.addEventListener('click', function (e) { if (e.target.closest('a') && input.value.trim()) remember(input.value); });
    root.querySelector('[data-n1-sr-recent-clear]').addEventListener('click', function () { setRecent([]); paintRecent(); input.focus(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = [].slice.call(panel.querySelectorAll('a')).filter(function (a) { return a.offsetParent; });
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : i - 1;
      if (i < 0) input.focus(); else items[i].focus();
    });
    clear.hidden = !input.value;
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-n1-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
